/* ===========================================================================
   mm-prefetch.js — Préchargement des pages au survol / au toucher
   ---------------------------------------------------------------------------
   BUT : réduire la latence ressentie au clic sur les cartes produit et les
   liens de navigation. Au survol (desktop) ou au premier contact tactile
   (mobile), on injecte <link rel="prefetch"> vers la page cible : le document
   HTML est téléchargé en arrière-plan (priorité basse) et mis en cache, donc
   au clic le navigateur n'attend plus le réseau pour le document.

   POINTS IMPORTANTS :
   - rel="prefetch" ne télécharge QUE le document HTML (pas son JS/CSS) et
     n'EXÉCUTE aucun script → ZÉRO impact sur le tracking (GTM/GA4/Meta), sur
     les sessions Shopify et sur l'A/B test (rien n'est compté tant que la page
     n'est pas réellement visitée).
   - Pris en charge par Chrome/Edge/Firefox (desktop + Android). Safari/iOS
     l'ignore en grande partie → le gain se concentre sur Chrome/Android.
   - Garde-fous : pas de prefetch du panier/checkout/compte, des liens externes,
     ni en mode « économie de données » ou connexion 2G.

   Chargé en `defer` depuis layout/theme.liquid (hors chemin critique).
   Pour désactiver le prefetch sur un lien précis : ajouter data-no-prefetch.
   =========================================================================== */
(function () {
  'use strict';

  // 1) Économie de données / connexion très lente → on n'active rien.
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn) {
    if (conn.saveData) return;
    if (/2g/.test(conn.effectiveType || '')) return; // 2g + slow-2g
  }
  try {
    if (window.matchMedia && matchMedia('(prefers-reduced-data: reduce)').matches) return;
  } catch (e) {}

  // 2) Le navigateur supporte-t-il rel="prefetch" ? Sinon, inutile d'écouter.
  var supported = (function () {
    var l = document.createElement('link');
    return l.relList && l.relList.supports && l.relList.supports('prefetch');
  })();
  if (!supported) return;

  var done = {};        // URLs déjà préchargées (dé-duplication)
  var MAX = 12;         // plafond par page (évite de marteler le serveur)
  var n = 0;
  var timer = null;
  var DELAY = 65;       // intention de survol : 65 ms avant de précharger

  // 3) Ce lien est-il éligible au prefetch ?
  function eligible(a) {
    if (!a || !a.href) return false;
    if (a.protocol !== 'http:' && a.protocol !== 'https:') return false; // exclut mailto:/tel:
    if (a.hostname !== location.hostname) return false;                  // même domaine seulement
    if (a.hasAttribute('download') || a.hasAttribute('data-no-prefetch')) return false;
    var p = a.pathname || '';
    if (/\/(cart|checkout|checkouts|account|logout)(\/|$)/.test(p)) return false;
    if (a.search && /(^|[?&])(add|variant|logout)/.test(a.search)) return false;
    var url = a.href.split('#')[0];
    if (url === location.href.split('#')[0]) return false;               // page courante
    if (done[url]) return false;
    return true;
  }

  // 4) Injection effective du <link rel="prefetch">.
  function prefetch(url) {
    if (done[url] || n >= MAX) return;
    done[url] = true;
    n++;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    document.head.appendChild(l);
  }

  // 5) Desktop : survol avec intention (petit délai, annulé si on quitte le lien).
  function onOver(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!eligible(a)) return;
    var url = a.href.split('#')[0];
    clearTimeout(timer);
    timer = setTimeout(function () { prefetch(url); }, DELAY);
  }
  function onOut() { clearTimeout(timer); }

  // 6) Mobile : au premier contact tactile (le clic suit ~100-300 ms plus tard).
  function onTouch(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!eligible(a)) return;
    prefetch(a.href.split('#')[0]);
  }

  document.addEventListener('mouseover', onOver, { capture: true, passive: true });
  document.addEventListener('mouseout', onOut, { capture: true, passive: true });
  document.addEventListener('touchstart', onTouch, { capture: true, passive: true });
})();
